import { render, staticRenderFns } from "./rolepermission.vue?vue&type=template&id=2269bc30&scoped=true&"
import script from "./rolepermission.vue?vue&type=script&lang=js&"
export * from "./rolepermission.vue?vue&type=script&lang=js&"
import style0 from "./rolepermission.vue?vue&type=style&index=0&id=2269bc30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269bc30",
  null
  
)

export default component.exports